export interface LanguageOption {
    code: string;
    label: string;
    /** ISO 3166-1 alpha-2 country code für flag-icons CSS-Klasse (fi fi-XX) */
    flagCode: string;
}

export const AVAILABLE_LANGUAGES: LanguageOption[] = [
    { code: 'de', label: 'Deutsch', flagCode: 'de' },
    { code: 'en', label: 'English', flagCode: 'gb' },
];
